import { Col, Container, Row } from "../../components";
import { useContextHook } from "../../Context/ContextOPen";
import { toScroll } from "../../Context/functions";
import { servicesList } from "../../Context/Lists";
import { content } from "../../lang/useLang";
import { useEffect, useRef, useState } from "react";

const Services = () => {
  const { direction } = useContextHook();
  const [isVisible, setIsVisible] = useState(false);
  const [animatedElements, setAnimatedElements] = useState({
    title: false,
    services: Array(servicesList.length).fill(false),
  });

  const servicesRef = useRef(null);

  // تتبع ظهور القسم
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // تفعيل الأنيميشن بالتسلسل
          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, title: true })),
            200
          );

          // تفعيل الخدمات بشكل تدريجي
          servicesList.forEach((_, index) => {
            setTimeout(() => {
              setAnimatedElements((prev) => ({
                ...prev,
                services: prev.services.map((item, i) =>
                  i === index ? true : item
                ),
              }));
            }, 400 + index * 150);
          });
        }
      },
      { threshold: 0.3 }
    );

    if (servicesRef?.current) {
      observer.observe(servicesRef?.current);
    }

    return () => {
      if (servicesRef?.current) {
        observer.unobserve(servicesRef?.current);
      }
    };
  }, []);

  return (
    <div
      ref={servicesRef}
      className="min-h-screen py-5 relative overflow-hidden transition-all duration-1000"
      style={{ direction }}
    >
      {/* تأثيرات الخلفية المحسنة */}
      <div className="absolute inset-0 overflow-hidden">
        {/* أشكال هندسية عائمة */}
        <div className="absolute top-20 left-10 w-16 h-16 bg-cyan-500/5 rounded-full animate-float-slow"></div>
        <div
          className="absolute top-40 right-20 w-12 h-12 bg-blue-500/5 rounded-full animate-float-medium"
          style={{ animationDelay: "2s" }}
        ></div>
        <div
          className="absolute bottom-32 left-1/4 w-20 h-20 bg-purple-500/3 rounded-full animate-float-slow"
          style={{ animationDelay: "4s" }}
        ></div>
        <div
          className="absolute bottom-20 right-32 w-14 h-14 bg-cyan-500/4 rounded-full animate-float-medium"
          style={{ animationDelay: "1s" }}
        ></div>

        {/* خطوط متقاطعة */}
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-cyan-500/15 to-transparent animate-scan-horizontal"></div>
        <div
          className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-blue-500/15 to-transparent animate-scan-horizontal"
          style={{ animationDelay: "2s" }}
        ></div>

        {/* شبكة خلفية */}
        <div className="absolute inset-0 opacity-5">
          <div
            className="w-full h-full"
            style={{
              backgroundImage: `radial-gradient(circle at 25% 25%, rgba(56, 189, 248, 0.1) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(59, 130, 246, 0.1) 0%, transparent 50%)`,
              backgroundSize: "60px 60px",
            }}
          ></div>
        </div>
      </div>

      <br />

      <Container className="relative z-10">
        {/* العنوان مع أنيميشن محسنة */}
        <div
          className={`text-center mb-8 transition-all duration-1000 ${
            isVisible && animatedElements.title
              ? "opacity-100 translate-y-0 scale-100"
              : "opacity-0 translate-y-10 scale-95"
          }`}
        >
          <h1
            className="text-4xl md:text-5xl font-bold mb-4 logo relative inline-block"
            style={{
              background:
                "linear-gradient(135deg, #38bdf8 0%, #3b82f6 50%, #6366f1 100%)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              backgroundClip: "text",
            }}
          >
            {content.services}
            {/* تأثير توهج تحت النص */}
            <div className="absolute -inset-4 bg-gradient-to-r from-cyan-500/10 to-blue-500/10 blur-xl rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-1000"></div>
          </h1>

          <div
            className={`w-24 h-1 bg-gradient-to-r from-cyan-400 to-blue-500 mx-auto rounded-full mb-4 transition-all duration-1000 delay-200 ${
              isVisible && animatedElements.title
                ? "opacity-100 translate-x-0 scale-x-100"
                : "opacity-0 translate-x-10 scale-x-0"
            }`}
          ></div>

          <p
            className={`text-gray-300 max-w-2xl mx-auto text-lg transition-all duration-1000 delay-300 ${
              isVisible && animatedElements.title
                ? "opacity-100 translate-y-0"
                : "opacity-0 translate-y-6"
            }`}
          >
            {content["desc_services"]}
          </p>
        </div>

        {/* عرض الخدمات */}
        <Row className="">
          {servicesList.map((item, i) => (
            <Col xs={6} sm={6} lg={3} key={i} className="mb-4 group">
              {/* البطاقة مع أنيميشن متتالية */}
              <div
                onClick={() => toScroll(6250)}
                className={`relative h-full transform transition-all duration-700 ${
                  animatedElements.services[i]
                    ? "opacity-100 translate-y-0 scale-100"
                    : "opacity-0 translate-y-8 scale-95"
                }`}
                style={{
                  transitionDelay: `${i * 150}ms`,
                }}
              >
                {/* تأثير خلفي للبطاقة */}
                <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 via-blue-500 to-purple-500 rounded-2xl blur opacity-20 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>

                {/* البطاقة الرئيسية */}
                <div className="relative bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-lg hover:shadow-xl transition-all duration-500 group-hover:-translate-y-1 border border-white/20 flex flex-col items-center text-center h-full ">
                  {/* أيقونة الخدمة مع تأثير محسن */}
                  <div className="absolute -top-2 left-1/2 transform -translate-x-1/2 z-20">
                    <div className="relative">
                      <div className="w-8 h-8 rounded-full bg-gradient-to-r from-cyan-500 to-blue-500 flex items-center justify-center shadow-md group-hover:scale-110 transition-transform duration-300 z-10 relative">
                        <span className="text-white font-bold text-xs">
                          {i + 1}
                        </span>
                      </div>
                      {/* تأثير توهج حول الأيقونة */}
                      <div className="absolute -inset-1 bg-cyan-500/20 rounded-full blur opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                    </div>
                  </div>

                  {/* صورة الخدمة مع تأثيرات محسنة */}
                  <div className="relative w-full h-32 overflow-hidden rounded-t-xl">
                    <img
                      src={item.image}
                      alt={content["services_" + (i + 1)]}
                      className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent opacity-50 group-hover:opacity-20 transition-all duration-500"></div>

                    {/* تأثير فوق الصورة */}
                    <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/10 to-blue-500/10 opacity-0 group-hover:opacity-100 transition-all duration-700"></div>
                  </div>

                  {/* النص مع تحسينات */}
                  <div className="p-3 flex flex-col items-center flex-grow w-full relative z-10">
                    <h3 className="text-sm font-bold text-gray-800 group-hover:text-transparent group-hover:bg-clip-text group-hover:bg-gradient-to-r group-hover:from-cyan-600 group-hover:to-blue-600 transition-all duration-500 mb-2 line-clamp-2">
                      {content["services_" + (i + 1)]}
                    </h3>
                    <p className="text-gray-600 text-xs leading-relaxed flex-grow line-clamp-3">
                      {content["desc_services_" + (i + 1)] ||
                        "نقدم خدمة متكاملة تلبي جميع احتياجاتكم بأعلى معايير الجودة."}
                    </p>

                    {/* زر التفاصيل مع تأثيرات محسنة */}
                    <button
                      style={{ direction: direction }}
                      className="mt-3 px-3 py-1 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-full text-xs font-medium  shadow hover:shadow-md transform hover:scale-105 transition-all duration-300 group-hover:from-cyan-600 group-hover:to-blue-600 flex items-center gap-1 relative overflow-hidden group/btn"
                    >
                      <span className="inline-block mr-1 transform group-hover:translate-x-1 transition-transform duration-300 relative z-10">
                        ←
                      </span>
                      <span className="relative z-10">{content["more"]}</span>
                    </button>
                  </div>

                  {/* نقاط زخرفية */}
                  <div className="absolute -top-1 -right-1 w-2 h-2 bg-cyan-400 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                  <div
                    className="absolute -bottom-1 -left-1 w-2 h-2 bg-blue-400 rounded-full animate-ping opacity-0 group-hover:opacity-100 transition-opacity duration-500"
                    style={{ animationDelay: "1s" }}
                  ></div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* نص إضافي في الأسفل */}
        <div
          className={`text-center mt-8 transition-all duration-1000 ${
            isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"
          }`}
          style={{ transitionDelay: "1000ms" }}
        >
          <p className="text-gray-400 text-sm max-w-3xl mx-auto leading-relaxed">
            {content["desc_services2"]}
          </p>
        </div>
      </Container>

      {/* الأنيميشن المخصصة */}
      <style jsx>{`
        @keyframes pulse-slow {
          0%,
          100% {
            opacity: 0.3;
            transform: scale(1);
          }
          50% {
            opacity: 0.6;
            transform: scale(1.1);
          }
        }
        @keyframes float-slow {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-15px) rotate(120deg);
          }
          66% {
            transform: translateY(8px) rotate(240deg);
          }
        }
        @keyframes float-medium {
          0%,
          100% {
            transform: translateY(0px) rotate(0deg);
          }
          33% {
            transform: translateY(-12px) rotate(-120deg);
          }
          66% {
            transform: translateY(6px) rotate(-240deg);
          }
        }
        @keyframes scan-horizontal {
          0% {
            transform: translateX(-100%);
          }
          100% {
            transform: translateX(100%);
          }
        }
        @keyframes shine {
          0% {
            transform: translateX(-100%) skewX(-12deg);
          }
          100% {
            transform: translateX(200%) skewX(-12deg);
          }
        }
        @keyframes service-glow {
          0% {
            border-color: transparent;
            box-shadow: 0 0 0 0 rgba(56, 189, 248, 0.7);
          }
          50% {
            border-color: rgba(56, 189, 248, 0.3);
            box-shadow: 0 0 0 10px rgba(56, 189, 248, 0);
          }
          100% {
            border-color: transparent;
            box-shadow: 0 0 0 0 rgba(56, 189, 248, 0);
          }
        }
        .animate-pulse-slow {
          animation: pulse-slow 8s ease-in-out infinite;
        }
        .animate-float-slow {
          animation: float-slow 8s ease-in-out infinite;
        }
        .animate-float-medium {
          animation: float-medium 6s ease-in-out infinite;
        }
        .animate-scan-horizontal {
          animation: scan-horizontal 4s linear infinite;
        }
        .animate-shine {
          animation: shine 2s ease-in-out;
        }
        .animate-service-glow {
          animation: service-glow 2s ease-in-out;
        }
        .animation-delay-2000 {
          animation-delay: 2s;
        }
      `}</style>
    </div>
  );
};

export default Services;
